export default __webpack_public_path__ + "static/media/ST1_SLEEK_LIGHT_550_B.20c7f94a.7c42a6ce.png";